const initialState = {
    data: [],
  };
  
  const mieszkancyAllWReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_MIESZKANCY_ALL_W':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default mieszkancyAllWReducer;